var WidgetListingTypeEnum;
(function (WidgetListingTypeEnum) {
    WidgetListingTypeEnum["partial"] = "partial";
    WidgetListingTypeEnum["complete"] = "complete";
})(WidgetListingTypeEnum || (WidgetListingTypeEnum = {}));
var WidgetRenderTypeEnum;
(function (WidgetRenderTypeEnum) {
    WidgetRenderTypeEnum["mosaic"] = "mosaic";
    WidgetRenderTypeEnum["list"] = "list";
})(WidgetRenderTypeEnum || (WidgetRenderTypeEnum = {}));
var StatusEnum;
(function (StatusEnum) {
    StatusEnum["enabled"] = "enabled";
    StatusEnum["disabled"] = "disabled";
})(StatusEnum || (StatusEnum = {}));
var CustomFileVariantsEnum;
(function (CustomFileVariantsEnum) {
    CustomFileVariantsEnum["cover"] = "cover";
    CustomFileVariantsEnum["homepage_cell"] = "homepage_cell";
    CustomFileVariantsEnum["instagram"] = "instagram";
    CustomFileVariantsEnum["interstitial"] = "interstitial";
    CustomFileVariantsEnum["list"] = "list";
    CustomFileVariantsEnum["list_nw"] = "list_nw";
    CustomFileVariantsEnum["list_accessory"] = "list_accessory";
    CustomFileVariantsEnum["list_accessory_nw"] = "list_accessory_nw";
    CustomFileVariantsEnum["news_banner"] = "news_banner";
    CustomFileVariantsEnum["news_banner_fit"] = "news_banner_fit";
    CustomFileVariantsEnum["news_cover"] = "news_cover";
    CustomFileVariantsEnum["news_slide"] = "news_slide";
    CustomFileVariantsEnum["news_thumbnail"] = "news_thumbnail";
    CustomFileVariantsEnum["og_image"] = "og_image";
    CustomFileVariantsEnum["press_list"] = "press_list";
    CustomFileVariantsEnum["press_view"] = "press_view";
    CustomFileVariantsEnum["report_banner"] = "report_banner";
    CustomFileVariantsEnum["showroom_list"] = "showroom_list";
    CustomFileVariantsEnum["showroom_list_accessory"] = "showroom_list_accessory";
    CustomFileVariantsEnum["showroom_view"] = "showroom_view";
    CustomFileVariantsEnum["showroom_zoom"] = "showroom_zoom";
    CustomFileVariantsEnum["talk_collection"] = "talk_collection";
    CustomFileVariantsEnum["talk_photo"] = "talk_photo";
    CustomFileVariantsEnum["talk_thumbnail"] = "talk_thumbnail";
    CustomFileVariantsEnum["thumbnail"] = "thumbnail";
    CustomFileVariantsEnum["view"] = "view";
    CustomFileVariantsEnum["view_nw"] = "view_nw";
    CustomFileVariantsEnum["zoom"] = "zoom";
    CustomFileVariantsEnum["zoom_nw"] = "zoom_nw";
})(CustomFileVariantsEnum || (CustomFileVariantsEnum = {}));
export { WidgetListingTypeEnum, WidgetRenderTypeEnum, CustomFileVariantsEnum, StatusEnum };
